import { LANGUAGE } from "@/constants/storage-type";
export default () => {
  let lang = localStorage.getItem(LANGUAGE);
  if (!lang) {
    const ln = navigator.language || navigator.userLanguage;

    if (ln.includes("en")) {
      lang = "en";
    } else if (ln.includes("es")) {
      lang = "es";
    } else {
      lang = "en";
    }
  }
  return lang;
};
